import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Message, Dropdown } from "semantic-ui-react";
import InlineError from "../messages/InlineError";

class StatementForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: {},
    };
  }


  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.submit(this.state.data);
    this.setState({ loading: false });
  };

  handleStateSelect = (e, data) => {
    this.props.periodChange(data.value);
  };

  validate = (data) => {
    const errors = {};
    if (!data.selectedMonth) errors.selectedMonth = "Select a month";
    return errors;
  };

  render() {
    const { errors, loading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {errors.global && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global}</p>
          </Message>
        )}
        <Form.Field error={!!errors.selectedMonth}>
          <label className="font-family" htmlFor="selectedMonth">
            Charges for
          </label>
          <Dropdown
            fluid
            search
            selectOnBlur={false}
            selection
            id={"statementMonth"}
            options={this.props.options}
            name={"statementMonth"}
            placeholder={"Select Month"}
            value={this.props.selectedMonth}
            onChange={this.handleStateSelect}
          />
          {errors.selectedMonth && <InlineError text={errors.selectedMonth} />}
        </Form.Field>

        <Button primary>Submit</Button>
      </Form>
    );
  }
}

StatementForm.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default StatementForm;



// WEBPACK FOOTER //
// ./src/components/forms/StatementForm.js